export const initialPageSizes = {
  bookingOptionsInsurances: 3,
  bookingOptionsProducts: 3,
  bookingOptionsBookingPlans: 4,
  customerPortalBookings: 5,
  customerPortalInvoiceHistory: 5,
  customerPortalOpenInvoices: 5,
  customerPortalSharedAccesses: 5,
  // This is the maximum page size for bulk fetching data from the API
  // Why? If I speak, big trouble
  bulkFetchPageSize: 30,
};
